import kinetikApi from './kinetikAPI';
export default {
  logout: () =>
    kinetikApi
      .post('/auth/user/logout', null, {
        withCredentials: true,
        serviceName: 'account',
      })
      .then((res) => res.data),
  self: (options) =>
    kinetikApi
      .get('/users/self', { ...options, serviceName: 'account' })
      .then((res) => res.data),
  userOrganizations: (options) =>
    kinetikApi
      .get('/users/self/organizations', { ...options, serviceName: 'account' })
      .then((res) => res.data),
  createAccessToken: () =>
    kinetikApi
      .post('/auth/user/access-token', null, {
        withCredentials: true,
        serviceName: 'account',
      })
      .then((res) => res.data),
  getRoles: (orgResourceId) =>
    kinetikApi
      .get('/users/self/roles', {
        params: { orgResourceId },
        withCredentials: false,
        serviceName: 'account',
      })
      .then((res) => res.data),
  getIntercomJwt: () =>
    kinetikApi
      .post('/auth/user/intercom-jwt', null, {
        withCredentials: true,
        serviceName: 'account',
      })
      .then((res) => res.data),
};
